import React, { useRef } from 'react';
import styles from './style.module.scss';

import  { send } from "@emailjs/browser";
import Rounded from '../../Projects/Test/common/RoundedButton';
import { useScroll, motion, useTransform } from 'framer-motion';
import Magnetic from '../../Projects/Test//common/Magnetic';
import Background from '../../assets/devshakilh/devshakilh.png'
import { toast } from 'react-toastify';

import './NewForm.css'
import { useState } from 'react';

export const metadata = {
    title: "Protfolio Contact",
    description: "devshakilh | Md Shakil Hosasin",
  };


export default function Index() {
  const container = useRef(null);
  const { scrollYProgress } = useScroll({
      target: container,
      offset: ["start end", "end end"]
  })
  const x = useTransform(scrollYProgress, [0, 1], [0, 100])
  const y = useTransform(scrollYProgress, [0, 1], [-500, 0])
  const rotate = useTransform(scrollYProgress, [0, 1], [120, 90])
  const [ setFocusedField] = useState('');
  


const [formData, setFormData] = useState({
    name: '',
    email: '',
    budget: '',
    service: '',
    details: '',
});

const [errors, setErrors] = useState({});

const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
        ...formData,
        [name]: value,
    });
    setErrors({
        ...errors,
        [name]: '',
    });
};


const handleFocus = (e) => {
    const { name } = e.target;
    setFocusedField(name);
};

const handleBlur = (e) => {
    const { name } = e.target;
    if (!formData[name]) {
        setFocusedField('');
    }
};



const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.budget) newErrors.budget = 'Project budget is required';
    if (!formData.service) newErrors.service = 'Service is required';
    if (!formData.details) newErrors.details = 'Project details are required';
    return newErrors;
};

const formRef = useRef();


    

 // Formspree endpoint URL
 const contactHandler = async (e) => {
    e.preventDefault();

    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
    }

    try {
        const formEndpoint = 'https://formspree.io/f/mzzpzblo'; // Replace with your Formspree form ID
        const response = await fetch(formEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });

        if (response.ok) {
            toast.success('Form received!');
            setFormData({
                name: '',
                email: '',
                budget: '',
                service: '',
                details: '',
            });
            setFocusedField('');
        } else {
            const errorData = await response.json();
            toast.error(`Error sending form: ${errorData.message || response.statusText}`);
        }
    } catch (error) {
        toast.error(`Network error: ${error.message}`);
    }
};




  return (
      <motion.div className={styles.contact}>
  <div className={styles.videoContainer}>
           {/* Persistent Background Video */}
          <video autoPlay loop muted className={styles.backgroundVideo}>
              <source src="/footer-video.mp4" type="video/mp4" />
               Your browser does not support the video tag.
            </video>
          </div>

          <div className={styles.body}>





              <div className={styles.title}>
                  <span>
                      <div className={styles.imageContainer}>
                          <img 
                              fill={true}
                              alt={"images"}
                              src={Background}
                          />
                      </div>
                      <h2>Let's work</h2>
                  </span>
                  <h2>together</h2>

                  <form
                    //   className="md:p-6 flex flex-col justify-center "
                      onSubmit={contactHandler}
                      ref={formRef}
                     
                  > 
                 
     

     
            <motion.div
                className={`form-group ${errors.name ? 'error' : ''}`}
                animate={{ borderColor: errors.name ? 'red' : 'white' }}
                transition={{ duration: 0.3 }}
            >
               {/* <label className='text-start text-white' htmlFor="name">Name</label> */}
             
                <input
                     type="name"
                     name="name"
                     id="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Muhammad"
                  
                />
                 
                <span className="error-text">{errors.name}</span>
            </motion.div>

            <motion.div
                className={`form-group ${errors.email ? 'error' : ''}`}
                animate={{ borderColor: errors.email ? 'red' : 'white' }}
                transition={{ duration: 0.3 }}
            >
                {/* <label className='text-start' htmlFor="email">Email</label> */}
                <input
                    type="email"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="example@example.com"
                />
                <span className="error-text">{errors.email}</span>
            </motion.div>
            
            <motion.div
                className={`form-group ${errors.budget ? 'error' : ''}`}
                animate={{ borderColor: errors.budget ? 'red' : 'white' }}
                transition={{ duration: 0.3 }}
            >
                {/* <label className='text-start' htmlFor="budget">Project Budget</label> */}
                <select
                    name="budget"
                    id="budget"
                    value={formData.budget}
                    onChange={handleChange}
                >
                    <option value="">Select Project Budget</option>
                    <option value="$1000-$5000">$1k-$5k </option>
                    <option value="5000-10000">$5k-$10k </option>
                    <option value="10k=20k">$10k-$20k </option>
                    <option value="20k-30k">$20k-$50k </option>
                    <option value="100k+">$100k Up </option>
                </select>
                <span className="error-text">{errors.budget}</span>
            </motion.div>
            
            <motion.div
                className={`form-group ${errors.service ? 'error' : ''}`}
                animate={{ borderColor: errors.service ? 'red' : 'white' }}
                transition={{ duration: 0.3 }}
            >
                {/* <label className='text-start' htmlFor="service">Service</label> */}
                <select
                    name="service"
                    id="service"
                    value={formData.service}
                    onChange={handleChange}
                >
                    <option value="">Select Service</option>
                    <option value="web-development">Web Development</option>
                    <option value="app-development">App Development</option>
                   
                    <option value="sass">Sass Design</option>
                    <option value="webflow">Webflow</option>
                    <option value="seo">SEO</option>
                </select>
                <span className="error-text">{errors.service}</span>
            </motion.div>
            
            <motion.div
                className={`form-group ${errors.details ? 'error' : ''}`}
                animate={{ borderColor: errors.details ? 'red' : 'white' }}
                transition={{ duration: 0.3 }}
            >
                {/* <label className='text-start' htmlFor="details">Project Details</label> */}
                <textarea
                    name="details"
                    id="details"
                    value={formData.details}
                    onChange={handleChange}
                    placeholder="Tell us more about your idea"
                />
                <span className="error-text">{errors.details}</span>
            </motion.div>
{/*             
            <motion.button
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
            >
                Submit
            </motion.button> */}
        
                     
                      <div className="text-start">
                          <button
                            //   className="group relative h-10 w-full md:w-40 overflow-hidden rounded-lg bg- shadow mt-5 px-1 mx-1"
                              type="submit"
                              value={send}
                          >
                              <motion.div style={{ x }} className={styles.buttonContainer}>
                                  <Rounded backgroundColor={"#334BD3"} className={styles.button}>
                                      <p>Send it!</p>
                                  </Rounded>
                              </motion.div>
                              <motion.svg style={{ rotate, scale: 2 }} width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8 8.5C8.27614 8.5 8.5 8.27614 8.5 8L8.5 3.5C8.5 3.22386 8.27614 3 8 3C7.72386 3 7.5 3.22386 7.5 3.5V7.5H3.5C3.22386 7.5 3 7.72386 3 8C3 8.27614 3.22386 8.5 3.5 8.5L8 8.5ZM0.646447 1.35355L7.64645 8.35355L8.35355 7.64645L1.35355 0.646447L0.646447 1.35355Z" fill="white" />
                              </motion.svg>
                          </button>
                      </div>
                  </form>
          

              </div>
              <div className={styles.nav}>
                  <Rounded>
                      <p >  <a href="mailto:mdshakil6565a@gmail.com">mdshakil6565a@gmail.com</a></p>
                  </Rounded>
                  <Rounded>
                      <p href="tel:+88 017 28 17 80 63">  +88 017 28 17 80 63  </p>
                  </Rounded>
              </div>
              <div className={styles.info}>
                  <div>
                      <span>
                          <h3>Version</h3>
                          <p>2023 © Edition</p>
                      </span>
                      <span>
                          <h3>Version</h3>
                          <p>11:49 PM GMT+2</p>
                      </span>
                  </div>
                  <div>
                      <span>
                          <h3>socials</h3>
                          <Magnetic>
                          <p>  <a href='https://www.github.com/devshakilh/'>GitHub</a></p>
                          </Magnetic>
                      </span>
                      <Magnetic>
                      <p>  <a href='https://www.linkedin.com/in/devshakilh/'>Linkedin</a></p>
                          
                      </Magnetic>
                      <Magnetic>
                        <p>  <a href='https://www.instagram.com/devshakilh/'>Instagram</a></p>
                      </Magnetic>
                      <Magnetic>
                        
                          <p><a href='https://www.facebook.com/devshakilh/'>Facebook</a></p>
                      </Magnetic>
                     
                  </div>
              </div>
          </div>
      </motion.div>
  );
};





